import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

export const FileTypeSvgIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    className={cn(className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4.49444 13.8576C9.613 14.7454 14.7317 14.7155 19.8502 13.8576V6.7415C19.8502 6.66042 19.824 6.58159 19.7753 6.51678L16.4046 2.0224C16.3338 1.92811 16.2228 1.87256 16.105 1.87256H5.61804C5.32006 1.87256 5.03422 1.99094 4.82352 2.20164C4.61282 2.41242 4.49444 2.69818 4.49444 2.99615V11.6104C4.49444 12.1667 4.36401 12.6381 4.36401 13.014C4.36401 13.5335 4.49444 13.8576 4.49444 13.8576Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M2.24719 12.8867V20.9737C2.24719 21.2716 2.36557 21.5575 2.57627 21.7682C2.78697 21.9789 3.07281 22.0973 3.37079 22.0973H20.5993C20.8973 22.0973 21.183 21.9789 21.3938 21.7682C21.6045 21.5575 21.7229 21.2716 21.7229 20.9737C21.7229 19.5385 21.7229 16.4164 21.7229 14.9812C21.7229 14.6832 21.6045 14.3974 21.3938 14.1867C21.183 13.976 20.8973 13.8576 20.5993 13.8576H3.74535C3.26751 13.8576 2.24719 12.8867 2.24719 12.8867Z"
      fill="#5E62B5"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M3.37079 13.8577C3.02886 13.8577 2.77924 13.719 2.59551 13.5482C2.42265 13.3875 2.24719 13.1042 2.24719 12.7341C2.24719 12.4965 2.36557 12.1502 2.57627 11.9396C2.78697 11.7289 3.07281 11.6105 3.37079 11.6105H4.49438V13.8577C4.49438 13.8577 4.59065 13.8577 3.37079 13.8577Z"
      fill="#414480"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.1049 1.87256V5.61791C16.1049 5.91588 16.2232 6.20173 16.4339 6.41242C16.6446 6.62312 16.9304 6.7415 17.2285 6.7415H19.8501C19.8501 6.66042 19.8239 6.58159 19.7752 6.51678L16.4045 2.0224C16.3337 1.92811 16.2227 1.87256 16.1049 1.87256Z"
      fill="#AFBDC7"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M15.8241 15.7303H15.8231C14.5826 15.7303 13.5769 16.7359 13.5769 17.9766V17.9775C13.5769 19.2186 14.583 20.2247 15.8241 20.2247C16.5398 20.2247 17.1941 19.8204 17.5141 19.1802C17.5415 19.1254 17.563 19.0825 17.563 19.0825C17.5887 19.0318 17.6031 18.9745 17.6031 18.9138V18.2115C17.6031 18.0047 17.4354 17.837 17.2286 17.8371H15.8241C15.6174 17.837 15.4495 18.0049 15.4495 18.2115C15.4495 18.4183 15.6174 18.5861 15.8241 18.5861H16.854V18.8254L16.8441 18.8452C16.651 19.2316 16.256 19.4756 15.8241 19.4756C14.9967 19.4756 14.3259 18.8049 14.3259 17.9775V17.9766C14.3259 17.1496 14.9962 16.4793 15.8231 16.4793H15.8241C16.044 16.4793 16.2541 16.5426 16.4331 16.6556C16.5485 16.7285 16.6509 16.8221 16.7345 16.9328C16.859 17.0978 17.0939 17.1307 17.259 17.0062C17.424 16.8817 17.4569 16.6467 17.3324 16.4817C17.194 16.2982 17.0243 16.143 16.8331 16.0222C16.5366 15.835 16.1883 15.7303 15.8241 15.7303Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M10.487 18.5861H12.1217C12.7703 18.5861 13.296 18.0604 13.296 17.4118V16.9046C13.296 16.256 12.7703 15.7303 12.1217 15.7303C11.2914 15.7303 10.1125 15.7303 10.1125 15.7303C9.90565 15.7303 9.73792 15.8979 9.73792 16.1048V19.8501C9.73792 20.0568 9.90574 20.2247 10.1125 20.2247C10.3192 20.2247 10.487 20.0568 10.487 19.8501V18.5861ZM10.487 17.837H12.1217C12.3565 17.837 12.5469 17.6467 12.5469 17.4118V16.9046C12.5469 16.6697 12.3565 16.4793 12.1217 16.4793H10.487V17.837Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M8.23978 16.1048V19.1576C8.23978 19.3333 8.0974 19.4756 7.92176 19.4756H7.43412C7.34981 19.4756 7.26891 19.4421 7.20931 19.3825C7.14963 19.3228 7.11619 19.2419 7.11619 19.1576V18.4456C7.11619 18.239 6.94837 18.0711 6.74163 18.0711C6.53489 18.0711 6.36707 18.239 6.36707 18.4456V19.1576C6.36707 19.4406 6.47951 19.712 6.6796 19.9121C6.87969 20.1122 7.15116 20.2247 7.43412 20.2247H7.92176C8.51107 20.2247 8.98882 19.7469 8.98882 19.1576V16.1048C8.98882 15.8981 8.821 15.7303 8.61426 15.7303C8.4076 15.7303 8.23978 15.8981 8.23978 16.1048Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M7.29627 12.57C7.2134 12.6668 7.19452 12.803 7.24782 12.9187C7.30104 13.0345 7.41681 13.1085 7.54427 13.1085H8.97996L10.6809 11.1206L9.89322 10.1999C9.82212 10.1168 9.71812 10.069 9.60863 10.069C9.49924 10.069 9.39524 10.1168 9.32405 10.1999C9.32405 10.1999 8.01564 11.7293 7.29627 12.57ZM9.96585 13.1085H16.8004C16.9277 13.1085 17.0435 13.0345 17.0968 12.9187C17.1501 12.803 17.1312 12.6668 17.0484 12.57C16.1009 11.4627 14.022 9.03302 14.022 9.03302C13.9508 8.94987 13.8469 8.90196 13.7374 8.90196C13.628 8.90196 13.524 8.94987 13.4529 9.03302L9.96585 13.1085ZM8.61421 5.61792C7.58068 5.61792 6.74158 6.45702 6.74158 7.49055C6.74158 8.52417 7.58068 9.36327 8.61421 9.36327C9.64782 9.36327 10.4869 8.52417 10.4869 7.49055C10.4869 6.45702 9.64782 5.61792 8.61421 5.61792Z"
      fill="#5E62B5"
      fillRule="evenodd"
    />
  </svg>
);

export default FileTypeSvgIcon;
